import PricingMethodWrapper from "./PricingMethodWrapper";

export default PricingMethodWrapper;
